
jQuery( document ).ready(function() {
                      console.log("LION KING");
// 	alert('testesdfsdf')
// 	$('.tier-modal.tierModal').addClass('modalClosed');
 if(jQuery(".tier-bundle").length){ 
	jQuery(".product-single__form").hide();
 }
});

// $(document).ready(function(){
//                   console.log("LION KING");
// // 	alert('testesdfsdf')
// // 	$('.tier-modal.tierModal').addClass('modalClosed');
//  if(jQuery(".tier-bundle").length){ 
// 	jQuery(".product-single__form").hide();
//  }                 
 
// })(jQuery);